import { actionTypes } from "../contants/actionTypes";

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: {},
    tokenId: '',
};

export const proveedorReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.floStartAddingNewProveedor:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case actionTypes.floFinishAddingNewProveedor:
            return {
                ...state,
                loading: false,
                success: true,
            };

        case actionTypes.floAddNewProveedorError:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };
        case actionTypes.supplierLoadingStartSingle:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case actionTypes.supplierLoadingFinishSingle:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.supplierLoadSupplierById:
            return {
                ...state,
                loading: false,
                success: true,
                data: action.payload,
            };
        case actionTypes.supplierErrorSingle:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };

        case actionTypes.supplierFetchStart:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case actionTypes.supplierFetchSuccess:
            return {
                ...state,
                loading: false,
                success: true,
                data: action.payload,
            };

        case actionTypes.supplierFetchError:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };
        case actionTypes.supplierFinishUpdate:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.supplierUpdate:
            return {
                ...state,
                loading: false,
                success: true,
                data: action.payload,
            };

        case actionTypes.supplierUpdateError:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case actionTypes.supplier:
            return {
                ...state,
                data: action.payload,
            };
        case actionTypes.token:
            return {
                ...state,
                tokenId: action.payload,
            };
        default:
            return state;
    }
};
